<template>
  <span>{{ mungedDuration }}</span>
</template>

<script setup lang="ts">
import { computed } from "vue";

const props = defineProps<{
  // Assume seconds.
  duration: number;
}>();

const mungedDuration = computed(() => {
  const minutes = Math.floor(props.duration / 60);
  if (minutes < 60) {
    return `${minutes} minutes`;
  }
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    return `${hours} hours`;
  }
  const days = Math.floor(hours / 24);
  if (days < 2) {
    return `a day and a half`;
  }
  if (days < 7) {
    return `${days} days`;
  }
  const weeks = Math.floor(days / 7);
  if (weeks < 2) {
    return `a little over a week`;
  }
  if (weeks < 4) {
    return `${weeks} weeks`;
  }
  if (days < 45) {
    return `over a month`;
  }
  if (days < 60) {
    return `almost two months`;
  }
  if (days < 90) {
    return `more than two months`;
  }
  const months = Math.floor(weeks / 4);
  if (months < 12) {
    return `${months} months`;
  }
  const years = Math.floor(months / 12);
  if (years === 1) {
    return `over a year`;
  }
  return `${years} years`;
});
</script>
